const fichaAvisoEmptyState = {
  'trabajos que pueden ser adecuados para vos!': 'trabajos que pueden ser adecuados para vos!',
  'trabajo que puede ser adecuado para vos!': 'trabajo que puede ser adecuado para vos!',
}

export default fichaAvisoEmptyState
